import React, { useEffect, useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
 
const documentSubTabs = [
  
              {
                  label: 'Dashboard',
                  to: '/contacts/dashboard',
              },
              {
                  label: 'All Contacts',
                  to: '/contacts/all',
              },
              {
                  label: 'Signup Forms',
                  to: '/contacts/signup-forms',
              },
              {
                  label: 'Tags',
                  to: '/contacts/tags',
              },
              {
                  label: 'Segments',
                  to: '/contacts/segments',
              },
              {
                  label: 'Add Contacts',
                  to: '/contacts/import',
              },
];

const templatesSubTabs = [  {
                label: 'All Campaigns',
                to: '/campaigns/all',
            },
            {
                label: 'Email Templates',
                to: '/campaigns/templates',
            },
];

const signSubTabs = [
  { label: "Dashboard", to: "/" },
];


const automationSubTabs = [
  { label: "All Automations", to: "/automation" },
  { label: "Automation Builder", to: "/automation/builder" },
];

const websiteSubTabs = [{ label: "Website", to: "/website" }];
const contentStudioSubTabs = [{ label: "Content Studio", to: "/content-studio" }];
const integrationSubTabs = [{ label: "Integration", to: "/integration" }];
const upgradePlansSubTabs = [{ label: "Upgrade Plans", to: "/upgrade-plans" }];

export default function TopNavigation() {
  const { pathname } = useLocation();

  const [showDocumentsTabs, setShowDocumentsTabs] = useState(false);
  const [showTemplatesTabs, setShowTemplatesTabs] = useState(false);
  const [showSignTabs, setShowSignTabs] = useState(false);
  const [showAutomationTabs, setShowAutomationTabs] = useState(false);
  const [showWebsiteTabs, setShowWebsiteTabs] = useState(false);
  const [showContentStudioTabs, setShowContentStudioTabs] = useState(false);
  const [showIntegrationTabs, setShowIntegrationTabs] = useState(false);
  const [showUpgradePlansTabs, setShowUpgradePlansTabs] = useState(false);

  useEffect(() => {
    setShowDocumentsTabs(pathname?.startsWith("/contacts"));
    setShowTemplatesTabs(pathname?.startsWith("/campaigns"));
    setShowSignTabs(
      pathname === "/" ||
      pathname?.startsWith("/otherSigner") ||
      pathname?.startsWith("/sign")
    );
    setShowAutomationTabs(pathname?.startsWith("/automation"));
    setShowWebsiteTabs(pathname?.startsWith("/website"));
    setShowContentStudioTabs(pathname?.startsWith("/content-studio"));
    setShowIntegrationTabs(pathname?.startsWith("/integration"));
    setShowUpgradePlansTabs(pathname?.startsWith("/upgrade-plans"));
  }, [pathname]);

  const getActiveTabValue = (tabs) => {
    // Exact match first
    const exactMatch = tabs.find(tab => pathname === tab.to);
    if (exactMatch) return exactMatch.to;

    // Sub-route match (e.g., /campaigns/edit/:id should match /campaigns/all)
    // For Campaigns, if it starts with /campaigns but isn't /campaigns/templates, it's /campaigns/all
    if (pathname.startsWith('/campaigns')) {
      if (pathname.startsWith('/campaigns/templates')) return '/campaigns/templates';
      return '/campaigns/all';
    }

    // For Contacts, similar logic
    if (pathname.startsWith('/contacts')) {
      if (pathname.startsWith('/contacts/all')) return '/contacts/all';
      if (pathname.startsWith('/contacts/signup-forms')) return '/contacts/signup-forms';
      if (pathname.startsWith('/contacts/tags')) return '/contacts/tags';
      if (pathname.startsWith('/contacts/segments')) return '/contacts/segments';
      if (pathname.startsWith('/contacts/import')) return '/contacts/import';
      if (pathname.startsWith('/contacts/edit')) return '/contacts/all'; // Contact edit goes to All Contacts tab
      return '/contacts/dashboard';
    }

    // For Automation
    if (pathname.startsWith('/automation')) {
      if (pathname.startsWith('/automation/builder')) return '/automation/builder';
      if (pathname.startsWith('/automation/report')) return '/automation';
      return '/automation';
    }

    const activeTab = tabs.find(tab => pathname.startsWith(tab.to));
    return activeTab ? activeTab.to : false;
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      {showDocumentsTabs && (
        <Tabs
          value={getActiveTabValue(documentSubTabs)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            "& .MuiTab-root": {
              minWidth: "unset",
              px: { xs: 1, sm: 2 },
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
            },
          }}
        >
          {documentSubTabs.map((sub) => (
            <Tab
              key={sub.to}
              label={sub.label}
              value={sub.to}
              component={NavLink}
              to={sub.to}
              disableRipple
            />
          ))}
        </Tabs>
      )}

      {showTemplatesTabs && (
        <Tabs
          value={getActiveTabValue(templatesSubTabs)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            "& .MuiTab-root": {
              minWidth: "unset",
              px: { xs: 1, sm: 2 },
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
            },
          }}
        >
          {templatesSubTabs.map((sub) => (
            <Tab
              key={sub.to}
              label={sub.label}
              value={sub.to}
              component={NavLink}
              to={sub.to}
              disableRipple
            />
          ))}
        </Tabs>
      )}

      {showSignTabs && (
        <Tabs
          value={pathname === "/" ? "/" : false}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            "& .MuiTab-root": {
              minWidth: "unset",
              px: { xs: 1, sm: 2 },
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
            },
          }}
        >
          {signSubTabs.map((sub) => (
            <Tab
              key={sub.to}
              label={sub.label}
              value={sub.to}
              component={NavLink}
              to={sub.to}
              disableRipple
            />
          ))}
        </Tabs>
      )}

      {showAutomationTabs && (
        <Tabs
          value={getActiveTabValue(automationSubTabs)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            "& .MuiTab-root": {
              minWidth: "unset",
              px: { xs: 1, sm: 2 },
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
            },
          }}
        >
          {automationSubTabs.map((sub) => (
            <Tab
              key={sub.to}
              label={sub.label}
              value={sub.to}
              component={NavLink}
              to={sub.to}
              disableRipple
            />
          ))}
        </Tabs>
      )}

      {showWebsiteTabs && (
        <Tabs
          value={pathname}
          variant="scrollable"
          sx={{ "& .MuiTab-root": { minWidth: "unset", px: 2 } }}
        >
          {websiteSubTabs.map((sub) => (
            <Tab key={sub.to} label={sub.label} value={sub.to} component={NavLink} to={sub.to} disableRipple />
          ))}
        </Tabs>
      )}

      {showContentStudioTabs && (
        <Tabs
          value={pathname}
          variant="scrollable"
          sx={{ "& .MuiTab-root": { minWidth: "unset", px: 2 } }}
        >
          {contentStudioSubTabs.map((sub) => (
            <Tab key={sub.to} label={sub.label} value={sub.to} component={NavLink} to={sub.to} disableRipple />
          ))}
        </Tabs>
      )}

      {showIntegrationTabs && (
        <Tabs
          value={pathname}
          variant="scrollable"
          sx={{ "& .MuiTab-root": { minWidth: "unset", px: 2 } }}
        >
          {integrationSubTabs.map((sub) => (
            <Tab key={sub.to} label={sub.label} value={sub.to} component={NavLink} to={sub.to} disableRipple />
          ))}
        </Tabs>
      )}

      {showUpgradePlansTabs && (
        <Tabs
          value={pathname}
          variant="scrollable"
          sx={{ "& .MuiTab-root": { minWidth: "unset", px: 2 } }}
        >
          {upgradePlansSubTabs.map((sub) => (
            <Tab key={sub.to} label={sub.label} value={sub.to} component={NavLink} to={sub.to} disableRipple />
          ))}
        </Tabs>
      )}
    </Box>
  );
}
